/**
 * @owner @Appboy/clx
 */

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { common } from "../common";

export const sendToDestinationStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("SEND_TO_DESTINATION"),
  step_data: z.object({
    destination_type: z.enum(["canvas", "decisioning_studio_agent"]),
    // The destination Canvas or agent ID, according to destination_type; null until one has been picked.
    destination_id: common.objectId.nullable(),
    // Sent only for clients that predate destination_id: the destination_id of a Canvas destination, else null.
    destination_canvas_id: common.objectId.nullable().optional(),
  }),
});
